<mat-card *ngIf="isLoaded">
    <mat-card-content>
        <p>{{'auth.newsletter.unsubscribe.summary' | translate}}</p>
    </mat-card-content>
</mat-card>
